export enum Webinar {
  REGISTER = 'REGISTER',
  REQUEST = 'REQUEST',
}
